angular.module('data-ng-todos').factory('TopicBuilder', function TopicBuilder(Interface) {
  'use strict';

  var TopicDTD = {
    topic: {
      type: 'object',
      typeDef: {
        id: 'key',
        name: 'string',
        rank: 'number',
        desc: 'string',
        has_opted_in: 'boolean'
      },
      writeToKey: 'topics'
    }
  };

  function TopicDTO(data) {
    Interface.implement(TopicDTD, data, this);
  }

  return TopicDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/builders/topic_builder.js